<template>
    <div class="job-detail job-detail--social-media-specialista">
        <div class="job-detail__heading">
            <h2>
                Máš vášeň pro sociální sítě, nápady a chceš nahlédnout pod pokličku reklamní agentury v centru Brna? 
            </h2>
        </div>
        <div class="job-detail__subheading">
            <div class="job-detail__subheading__spacer-block">
                <div class="job-detail__subheading__spacer-block__line"></div>
            </div>
            <div class="job-detail__subheading__text-block">
                <p>Do týmu hledáme Social Media Specialist(k)u, který/která nám pomůže pečovat o online prezentaci našich klientů. Pokud se nebojíš samostatné práce a máš chuť se učit a přicházet s vlastními nápady, přidej se k nám!</p>
            </div>
        </div>
        <div class="job-detail__text">
            <br><br>
            <h3>Co tě u nás čeká?</h3>
            <ul>
                <li>Aktivně se podílet na tvorbě obsahové strategie</li>
                <li>Spolupracovat na tvorbě scénářů, storyboardů a nápadů</li>
                <li>Pomáhat s produkcí video a foto obsahu</li>
                <li>Podpora při vytváření příspěvků, stříhání a úprava video obsahu (reels, stories), práce s grafickými nástroji</li>
                <li>Přicházet s vlastními kreativními nápady na obsah a kampaně, sledovat nejnovější trendy a navrhovat inovativní přístupy</li>
                <li>Pomáhat se správou a rozvojem profilů klientů na různých sociálních platformách</li>
                <li>Analyzovat výsledky a hledat cesty, jak zlepšit výkonnost klientů na sociálních sítích.</li>
                <li>Prostor pro vlastní iniciativu a samostatné řešení úkolů</li>
                <li>Učit se a růst v dynamickém prostředí</li>
            </ul>
            <br><br>
            <h3>Co oceníme u tebe?</h3>
            <ul>
                <li>Baví tě sociální sítě a rozumíš jim (alespoň základní znalost).</li>
                <li>Chuť učit se novým věcem a aktivní přístup k práci.</li>
                <li>Kreativitu a schopnost přicházet s novými nápady.</li>
                <li>Komunikativnost a zodpovědnost.</li>
                <li>Možnost docházet do naší kanceláře v centru Brna.</li>
            </ul>
            <br><br>
            <h3>Co ti nabízíme?</h3>
            <ul>
                <li>Flexibilní pracovní dobu, kterou si můžeš přizpůsobit studiu či dalším povinnostem.</li>
                <li>Možnost získat cenné praktické zkušenosti v oblasti online marketingu.</li>
                <li>Práci na zajímavých projektech pro různorodé klienty.</li>
                <li>Přátelský tým a otevřenou komunikaci.</li>
                <li>Práci na dohodu, zkrácený úvazek nebo spolupráci na IČO.</li>
                <li>Kanceláře v centru Brna a další benefity po dohodě.</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    .job-detail {
        h2 {
            color: #212529;
            letter-spacing: -.02em;
            margin-top: 0;
            margin-bottom: 0;
            font-size: 30px;
            font-weight: 700;
            line-height: 100%;
            text-align: center;

            @media (min-width: 768px) {
                font-size: 40px;
                text-align: left;
            }

            @media (min-width: 992px) {
                font-size: 50px;
            }

            @media (min-width: 1200px) {
                font-size: 68px;
            }
        }

        .job-detail__heading {
            margin-bottom: 40px;
        }

        .job-detail__subheading {
            .job-detail__subheading__text-block {
                p {
                    color: rgb(130, 131, 132);
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 1.5;
                    text-align: center;
                }
            }

            @media (max-width: 767px) {
                .job-detail__subheading__spacer-block {
                    display: none;
                }
            }

            @media (min-width: 768px) {
                display: flex;
                grid-column-gap: 32px;
                justify-content: space-between;
                align-items: baseline;

                .job-detail__subheading__spacer-block {
                    flex: 1;
                    .job-detail__subheading__spacer-block__line {
                        background-color: rgb(130, 131, 132);
                        width: 100%;
                        height: 1px;
                    }
                }

                .job-detail__subheading__text-block {
                    width: 68%;

                    p {
                        font-size: 22px;
                        text-align: left;
                    }
                }
            }
        }

        .job-detail__text {
            h3 {
                font-size: 26px;
                line-height: 1.1;
                font-weight: 900;
                margin: 0 0 0.68em;
                padding: 0;

                @media (min-width: 768px) {
                    font-size: 30px;
                }

                @media (min-width: 992px) {
                    font-size: 36px;
                }

                @media (min-width: 1200px) {
                    font-size: 42px;
                }
            }

            ul {
                padding-left: 12px;
                list-style-type: "–";
                margin: 0;
                li {
                    padding: 0 0 6px 12px;
                    font-size: 18px;
                    line-height: 1.6;
                    color: #212529;
                }
            }
        }
    }
</style>